import React from 'react';
import { Translate } from 'react-jhipster';

import MenuItem from 'app/shared/layout/menus/menu-item';

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      <MenuItem icon="asterisk" to="/facility-warehouse">
        <Translate contentKey="global.menu.entities.facilityWarehouse" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/receipt">
        <Translate contentKey="global.menu.entities.receipt" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/artikeltexte-did">
        <Translate contentKey="global.menu.entities.artikeltexteDid" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/artikeltexte">
        <Translate contentKey="global.menu.entities.artikeltexte" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/replacement-item">
        <Translate contentKey="global.menu.entities.replacementItem" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/data-identifier-ssc">
        <Translate contentKey="global.menu.entities.dataIdentifierSsc" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/deployment">
        <Translate contentKey="global.menu.entities.deployment" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/transport-order">
        <Translate contentKey="global.menu.entities.transportOrder" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/vehicle">
        <Translate contentKey="global.menu.entities.vehicle" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/company">
        <Translate contentKey="global.menu.entities.company" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/branch-master">
        <Translate contentKey="global.menu.entities.branchMaster" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
